import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionConfigs from '../store/collections/questionConfigs'

export function useQuestionConfigs(reviewId: number) {
  const { loading } = useUnsafeAsyncData(
    async () =>
      questionConfigs.fetch({
        data: {
          surveys_form_id: reviewId,
        },
      }),
    [reviewId]
  )

  return {
    loading,
    questionConfigs: questionConfigs.filter({
      surveys_form_id: reviewId,
    }),
  }
}
